<template>
  <div id="app">
    <header>
      <div class="container">
        <div class="logo">
          <router-link :to="{ name: 'home' }">
            <picture>
              <source
                srcset="./assets/logo.svg"
                media="(min-width: 1024px)"
              >
              <img
                src="./assets/icon.svg"
                alt="Gun Group"
                class="img-fluid"
              >
            </picture>
          </router-link>
        </div>

        <header-search v-if="userData" />

        <template v-if="userData">
          <dropdown-menu
            id="header-notifications-menu"
            class="header-notifications"
            align-right
            hide-chevron
          >
            <template v-slot:button>
              <router-link
                :to="{ name: 'notifications' }"
                event=""
                @click.native.prevent="showHeaderNotifications = true"
              >
                <notifications-bell />
                <notification-badge />
              </router-link>
            </template>

            <template v-slot:dropdownContent>
              <notifications v-if="showHeaderNotifications" />
            </template>
          </dropdown-menu>

          <messages class="header-messages" />

          <dropdown-menu
            id="user-menu"
            align-right
          >
            <template v-slot:button>
              <avatar :size="24" />
            </template>

            <li>
              <router-link :to="{ name: 'profile', params: { id: userData.id } }">
                Profile
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'update_profile' }">
                Settings
              </router-link>
            </li>
            <li>
              <router-link :to="{ name: 'logout' }">
                Log Out
              </router-link>
            </li>
          </dropdown-menu>
        </template>
      </div>
    </header>

    <div class="container">
      <sidebar v-if="this.$route.name !== 'more'" />

      <main>
        <router-view />
      </main>
    </div>

    <bottom-bar
      v-show="
        ![
          'conversations_conversation',
          'conversations_conversations',
          'conversations_archived',
          'conversations_deleted',
        ].includes($route.name)
      "
    />
  </div>
</template>

<script>
import debug from 'debug';
import { mapState } from 'vuex';
import ChatAppMixin from '@virgodev/chat/mixins/ChatAppMixin';
import NotificationBadge from '@virgodev/notifications/components/NotificationBadge.vue';
import { addResponseHandler } from '@virgodev/bazaar/functions/api';

import Avatar from '@/components/Avatar.vue';
import BottomBar from '@/components/BottomBar.vue';
import DropdownMenu from '@/components/DropdownMenu.vue';
import HeaderSearch from '@/components/HeaderSearch.vue';
import Messages from '@/components/Messages.vue';
import Notifications from '@/components/Notifications.vue';
import NotificationsBell from '@/components/NotificationsBell.vue';
import Sidebar from '@/components/Sidebar.vue';

require('vue-image-lightbox/dist/vue-image-lightbox.min.css');

const log = debug('app');

// eslint-disable-next-line
console.log(
  '%cNEVER paste code here, your safety and identity are at risk!',
  'background: black; color: deeppink; font-size: 30px; padding: 10px',
);

export default {
  metaInfo: {
    title: 'Gun Group',
  },
  components: {
    Avatar,
    BottomBar,
    DropdownMenu,
    HeaderSearch,
    Messages,
    Notifications,
    NotificationBadge,
    NotificationsBell,
    Sidebar,
  },
  mixins: [ChatAppMixin],
  data() {
    const { userData } = this.$store.state;
    return {
      wsToken: userData ? userData.drf_token : null,
      showHeaderNotifications: false,
    };
  },
  computed: {
    isAdmin() {
      return (this.userData && this.userData.is_staff) || this.isGroupAdmin;
    },
    isGroupAdmin() {
      return this.userGroups.some(g => g.is_admin);
    },
    ...mapState([
      'categories',
    ]),
  },
  watch: {
    'userData.drf_token': function tokenChanged(newValue) {
      log(`token changed ${newValue}`);
      this.wsToken = newValue;
    },
    userData() {
      if (this.userData) {
        this.$store.dispatch('fetchUserGroups');
      }
    },
  },
  async created() {
    this.$store.dispatch('categories');
    this.$store.dispatch('fetchTags');
    if (this.userData && this.userData.id) {
      this.$store.dispatch('fetchUserGroups');
    }

    // if user gets 401 messages
    // they need to login
    addResponseHandler(401, () => {
      this.$store.commit('userData', null);
      this.$store.commit('groupData', []);
    });
  },
  methods: {
  },
};
</script>

<style lang="scss">
@import './style.scss';
</style>
